<template>
	<div
		class="bg-fill-tertiary z-2 -mb-px flex justify-center"
		style="padding-bottom: var(--padding-bottom)"
	>
		<div class="flex h-18 w-full max-w-92.5">
			<template v-for="route in routes">
				<RouterLink
					v-if="route.route"
					:key="route.route"
					:to="route.route"
					custom
					v-slot="{ isExactActive, navigate }"
				>
					<div
						class="text-label-tertiary flex flex-1 flex-col items-center gap-1.5 py-3"
						@click="navigate"
					>
						<Component
							:is="route.icon"
							class="h-6 w-6"
							:class="{ 'text-red': isExactActive }"
						/>
						<div
							class="truncate text-xs font-medium capitalize"
							:class="{ 'text-label-primary': isExactActive }"
						>
							{{ route.name }}
						</div>
					</div>
				</RouterLink>
				<div
					v-else
					class="text-label-tertiary flex flex-1 flex-col items-center gap-1.5 py-3"
					@click="openChat"
				>
					<Component :is="route.icon" class="h-6 w-6" />
					<div class="truncate text-xs font-medium capitalize">
						{{ route.name }}
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script setup lang="ts">
import RewardsIcon from '@/assets/icons/rewards.svg'
import InvitesIcon from '@/assets/icons/invites.svg'
import GamesIcon from '@/assets/icons/games.svg'
import MarketIcon from '@/assets/icons/market.svg'
import ChatIcon from '@/assets/icons/chat.svg'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { WebApp } from '@grammyjs/web-app'

const { t } = useI18n({
	messages: {
		en: {
			games: 'games',
			rewards: 'rewards',
			invites: 'invites',
			market: 'market',
			chat: 'chat'
		},
		ru: {
			games: 'игры',
			rewards: 'награды',
			invites: 'рефералы',
			market: 'маркет',
			chat: 'чат'
		}
	}
})

const routes = computed(() => [
	{
		route: '/',
		name: t('games'),
		icon: GamesIcon
	},
	{
		route: '/rewards',
		name: t('rewards'),
		icon: RewardsIcon
	},
	{
		route: '/invites',
		name: t('invites'),
		icon: InvitesIcon
	},
	{
		route: '/market',
		name: t('market'),
		icon: MarketIcon
	},
	{
		name: t('chat'),
		icon: ChatIcon
	}
])

const openChat = () => {
	try {
		const res = WebApp.openTelegramLink('https://t.me/RageLounge')

		console.info('Open telegram link', res)
	} catch (e) {
		console.error('Failed to open Telegram link:', e)
	}
}
</script>
